module.exports = __webpack_public_path__ + "img/2.45df14e1.png";